import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import World from "@fae/source/models/World.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"
import * as PlotScripts from "@fae/source/data/plot/scripts.js"

import Navigation from "@fae/source/engine/navigating/Navigation.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Step from "@fae/source/models/Step.js"
import Objdict from "objdict"

import ProgressReport from "@fae/source/data/games/school/views/ProgressReport.jsx"
import ProgressReportsHUD from "@fae/source/data/games/school/views/ProgressReportsHUD.jsx"
import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"

import HandleSlowDeath from "@fae/source/data/games/ember/scripts/HandleSlowDeath.js"
import HandleStatusEffects from "@fae/source/data/games/ember/scripts/HandleStatusEffects.js"
import HandleArmor from "@fae/source/data/games/ember/scripts/HandleArmor.js"
import GenerateStudents from "@fae/source/data/games/school/scripts/GenerateStudents.js"

import ChapterSummary from "@fae/source/data/games/school/scripts/ChapterSummary.jsx"
import LevelUp from "@fae/source/data/games/school/scripts/LevelUp.jsx"
import SavePlayerState from "@fae/source/data/games/school/scripts/SavePlayerState.js"

export default {
    "key": "punks",
    "stage": {
        "images": [
            {
                "url": require("../../dotgridbg.png"),
                "position": {"x": 0, "y": 0, "z": -1},
                "screenspace": "camera",
                "width": 16, "height": 9,
            },
            // {
            //     "url": require("./room.png"),
            //     "position": {"x": 0, "y": 0, "z": 2},
            //     "width": 16, "height": 9,
            //     "isSquiggling": true,
            // },
            {
                "type": "lined-polygon",
                "position": {"x": 0, "y": 0, "z": 2},
                "points": require("./encounters.json")[0].points,
                "color": "#000",
                "isSquiggling": true,
            }
        ],
        "units": require("./units.json"),
        "world": World.parse({
            "width": 16,
            "height": 9,
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "hud": function(stage) {
            if(stage?.flags["hud"] == "hidden") {
                return (
                    <div class="TutorialPrompt" isHidden={true}/>
                )
            }

            return (
                <ProgressReportsHUD stage={stage}/>
            )

            // if(stage.flags["tutorial:hasRallied"] != true) {
            //     return (
            //         <div class="TutorialPrompt" position="topright">
            //             <div class="Text">
            //                 The firekeeper has the power to RALLY her friends,
            //                 allowing them to act twice in a turn.
            //             </div>
            //         </div>
            //     )
            // }
            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        },
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    Step.flag("hud", "hidden"),
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.SpawnPlayerParty({"spotTag": "goodspawn"}),
                    PlotSteps.PlayAudio("Ember:Music:Combat"),
                    function() {
                        const currentTime = App?.game?.overworld?.currentTime ?? 1
                        return GenerateStudents({
                            "unitCount": currentTime <= 3 ? 3 : 6,
                            "jobKeys": currentTime <= 2 ? ["school/sword"] : ["school/sword", "school/sword", "school/sword", "school/dagger"],
                            "level": Math.min(5, Math.max(1, Math.ceil(currentTime / 2) + 0)),
                            "title": "Punk",
                            "images": {
                                "school/sword": require("@fae/source/assets/images/teach-tactics/mapsprite-punkred.png"),
                                "school/dagger": require("@fae/source/assets/images/teach-tactics/mapsprite-punkred.png"),
                                // "school/axe": require("@fae/source/assets/images/teach-tactics/mapsprite-punkgreen.png"),
                                // "school/spear": require("@fae/source/assets/images/teach-tactics/mapsprite-punkblue.png"),
                                // "school/bow": require("@fae/source/assets/images/teach-tactics/mapsprite-punkblue.png"),
                            }
                        })
                    },
                    (stage) => {
                        if(window.hasSeenPunkDialogue != true) {
                            window.hasSeenPunkDialogue = true // TODO: turn this into flags
                            return [
                                "Tough: GRRRRAH -- another Teach here to tell me to sit still and listen??",
                                "Punk: We learns more than in any stuffy classroom out here -- in the school of hardknocks!",
                                "Teacher: Hmmm. Self-driven AND experiential active learning *would* engage their cognition more...",
                                "Teacher: Yes. Ruby, let's follow our classmates' reasoning. Share with them what you've been practicing",
                                "Nerd: Wait!",
                            ]
                        }
                    },
                    Step.flag("modal", null),
                    Step.flag("hud", null),
                    // LevelUp({"unitKey": "nerd"}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                        || PlotConditions.areAllAffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation,
                            "doNotIncludeUnitKey": "teacher"
                        })
                },
                "events": [
                    PlotSteps.ChapterSuccess({"message": "Class Dismissed"}),
                    ChapterSummary(),
                    LevelUp(),
                    function(stage) {
                        if(App.game.player.units.punk.isRecruited != true) {
                            return [
                                "PUNK: STUBBORN, AIN'TCHA.",
                                "PUNK: I'LL JOIN YOUR LITTLE PARTY, BUT ONLY BECAUSE I'VE GOT NOTHING BETTER GOING ON",
                                "THE PUNK HAS JOINED YOUR PARTY!!",
                                {"func": () => {
                                    App.game.player.units.punk.isRecruited = true
                                    App.game.player.units.punk.affiliation = "good"
                                }},
                                Step.deltastage({"unit": {"key": "punk", "affiliation": "good"}}),
                            ]
                        }
                    },
                    PlotSteps.TransitionStart({"isUnskippable": true}),
                    {"func": () => Navigation.go("/games/school/overworld")},
                    PlotSteps.TransitionEnd({"isUnskippable": true}),
                    PlotSteps.Wait(500),
                    {"func": () => App.game.player.overworld.currentTime += 1},
                    SavePlayerState(),
                    // if not unlocked yet, unlock ch2
                ]
            },
            {
                "trigger": "turn:every-odd:end",
                "events": [
                    HandleSlowDeath(),
                    HandleStatusEffects(),
                    HandleArmor(),
                ]
            },
        ]
    },
}
